module.exports = __webpack_public_path__ + "img/pr-6.cf1ba260.png";